<template>
	<v-hover v-slot="{ hover }">
		<v-card
			:color="category.color"
			:elevation="hover ? 10 : 2"
			:class="['category-card', { 'on-hover scale': hover }]"
		>
			<v-card-text
				:class="[
					$vuetify.breakpoint.smAndDown ? 'pa-3 pt-0 pb-1' : 'pl-10',
					'pr-10',
				]"
			>
				<v-row justify="center">
					<v-col
						cols="12"
						md="10"
						class="card-text pb-0 pt-0 d-flex justify-space-between align-center white--text"
					>
						<div class="d-flex flex-column">
							<h1 class="mb-3" v-if="$vuetify.breakpoint.mdAndUp">
								{{ category.name }}
							</h1>

							<h2 v-else>
								{{ category.name }}
							</h2>

							<p class="ma-0 mt-1">
								{{ category.description }}
							</p>
						</div>
					</v-col>

					<v-col
						cols="12"
						md="2"
						:class="[
							'd-flex',
							'align-center',
							'justify-end',
							{ 'pt-0': $vuetify.breakpoint.smAndDown },
						]"
					>
						<v-btn color="primary">ver mas</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-hover>
</template>

<script>
export default {
	name: "LargeCard",

	props: ["category"],

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped>
.category-card {
	cursor: pointer;
	min-height: 160px;
	position: relative;
	transition: all 0.2s;
}

.card-text {
	height: 125px;
}

.card-actions {
	background-color: rgba(0, 0, 0, 0.08);
}
</style>
